module.exports = __webpack_public_path__ + "images/pages/for_business/sp/img01_16f5cd150af0b4f59083c5acaf6b0124.png";